import React, { Suspense } from 'react';

import Flex from '../flex-container';
import Loader from '../loader';

const loader = (
  <Flex justifyContent="center" alignItems="center" flex={1}>
    <Loader />
  </Flex>
);

export default function CodeSplit(Component, props) {
  return (
    <Suspense fallback={loader}>
      <Component {...props} />
    </Suspense>
  );
}
